var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEd1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    enableBackground: "new 0 0 64 64",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m60 14h-33v-2c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2v2h-2v-2c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2v2h-2v-2c0-1.103-.897-2-2-2h-2c-1.103 0-2 .897-2 2v2h-1c-1.654 0-3 1.346-3 3v34c0 1.654 1.346 3 3 3h56c1.654 0 3-1.346 3-3v-19-6-2-6-1c0-1.654-1.346-3-3-3zm-37-2h2l.001 6h-2.001zm-8 0h2l.001 6h-2.001zm-8 0h2l.001 6h-2.001zm-2 32h-2v-2h2zm31 8h-4v-2h4zm10 0h-4v-2h4zm15-22h-2v-2h2zm0-4h-4v2h-9v-4h-2v-2h11v2h4zm-29 14v-14h14v14zm27-18v-2h2v2zm-2-4v2h-13v4h-2v-2h-2v2h-2v-2h-2v2h-2v-2h-2v2h-2v2h-4v-4h-10v2h8v4h6v2h-8v-4h-11.184c-.414-1.161-1.514-2-2.816-2-1.654 0-3 1.346-3 3s1.346 3 3 3c1.302 0 2.402-.839 2.816-2h9.184v4h10v2h-2v2h2v2h-2v2h2v2h2v2h2v-2h2v2h2v-2h2v2h2v-2h2v2h2v-2h2v-2h2v-2h-2v-2h2v-2h-2v-4h9v2h4v19c0 .551-.448 1-1 1h-12v-4h-8v4h-2v-4h-8v4h-26c-.552 0-1-.449-1-1v-5h2v2h8v-2h2v2h8v-2h2v-2h-2v-2h2v-2h-2v-2h-8v2h-2v-2h-8v2h-2v-23c0-.551.448-1 1-1h1v2c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2v-2h2v2c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2v-2h2v2c0 1.103.897 2 2 2h2c1.103 0 2-.897 2-2v-2h33c.552 0 1 .449 1 1v1zm-48 9c0 .551-.448 1-1 1s-1-.449-1-1 .448-1 1-1 1 .449 1 1zm-2 19v-6h4v6zm6-4h2v2h-2zm4 4v-6h4v6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34 38h10v-10h-10zm2-8h6v6h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 22h2v2h-2z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 49,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 45,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 45,
    r: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEd1);
export default __webpack_public_path__ + "static/media/ED1.65ea9098.svg";
export { ForwardRef as ReactComponent };